import { useState } from "react";
import { Copy, Check, Eye, EyeOff } from "lucide-react";

/** Pun ključ uvek dostupan u panelu: prikaži/sakrij + kopiraj. */
export function KeyReveal({ value }: { value: string | null | undefined }) {
  const [show, setShow] = useState(false);
  const [done, setDone] = useState(false);
  if (!value) {
    return <p className="mt-1 text-xs text-slate-400">Pun ključ nije sačuvan (stari ključ). Napravite novi - novi se uvek vide ovde.</p>;
  }
  return (
    <div className="mt-1 flex items-center gap-2">
      <code className="max-w-full truncate rounded bg-slate-100 px-2 py-1 font-mono text-xs text-slate-800">
        {show ? value : value.slice(0, 10) + "•".repeat(16)}
      </code>
      <button type="button" className="text-slate-500 hover:text-slate-800" aria-label={show ? "Sakrij" : "Prikaži"} onClick={() => setShow(!show)}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
      <button
        type="button"
        className="text-slate-500 hover:text-slate-800"
        aria-label="Kopiraj"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(value);
            setDone(true);
            setTimeout(() => setDone(false), 1500);
          } catch {
            /* ignore */
          }
        }}
      >
        {done ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
      </button>
    </div>
  );
}
